import { render, staticRenderFns } from "./mine_favorites.vue?vue&type=template&id=53b788d0&lang=pug&"
import script from "./mine_favorites.vue?vue&type=script&lang=js&"
export * from "./mine_favorites.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports